import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.eventTrackingUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken.replace('BEARER', 'Bearer')
    }
  })

const eventTrackingApi = {
  getTrackingUrls: (pageId, params) => instance().get(`/v1/tracking-url/cms/${pageId}`, { params }),
  getLonAnalyticsDetail: (pageId, data) =>
    instance().post(`/v1/events/cms/${pageId}/analytic/lon/dashboard/detail`, data)
}

export default eventTrackingApi



// WEBPACK FOOTER //
// ./src/api/event-tracking.js